import {BrowserModule, Title} from "@angular/platform-browser";
import {NgModule, provideZoneChangeDetection} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { ScrollingModule } from "@angular/cdk/scrolling";

import {AppComponent} from "./app.component";
import {AppRoutingModule} from "./app-routing.module";
import {AssigneeComponent} from "./assignee/assignee.component";
import {PopulationRulesComponent} from "./clients/client/populations/population-rules/population-rules.component";
import {DocumentComponent} from "./document/document.component";
import {AnswerComponent} from "./answer/answer.component";
import {NavbarComponent} from "./navbar/navbar.component";
import {ReturnsComponent} from "./returns/returns.component";
import {SidebarComponent} from "./sidebar/sidebar.component";
import {TaxReturnsModule} from "./tax-returns/tax-returns.module";
import {SharedModule} from "../shared/shared.module";
import {TaxpayersSearchModule} from "./taxpayers-search/taxpayers-search.module";
import {ClientsModule} from "./clients/clients.module";
import {ClientSidebarComponent} from "./sidebar/client-sidebar/client-sidebar.component";
import {TaxReturnSidebarComponent} from "./sidebar/tax-return-sidebar/tax-return-sidebar.component";
import {CleanElementSelectorPipe} from "../shared/pipes/clean-element-selector.pipe";
import {APIS, Configuration} from "../../swaggerServices";
import {PopulationSidebarComponent} from "./sidebar/population-sidebar/population-sidebar.component";
import {LoginModule} from "./login/login.module";
import {ClockService} from "../shared/util/clock.service";
import {ClientRulesSidebarComponent} from "./sidebar/client-rules-sidebar/client-rules-sidebar.component";
import {SettingsModule} from "./settings/settings.module";
import { DynamicSourcesComponent } from "./dynamic-sources/dynamic-sources.component";
import { DynamicSourcesDropdownComponent } from "./dynamic-sources-dropdown/dynamic-sources-dropdown.component";
import {AppHttpInterceptor} from "./interceptor/http.interceptor";
import {EncodeJsonInterceptor} from "./interceptor/encode-json.interceptor";
import {WafRuleInterceptor} from "./interceptor/waf-rule.interceptor";
import {ClientNotificationService} from "./client-notification.service";
import {NoticesModule} from "./notices/notices.module";
import { MsalModule } from "@azure/msal-angular";
import {MsalConfigDynamicModule} from "../app/settings/msal-instance-factory.service";
import { APP_BASE_HREF, PlatformLocation } from "@angular/common";
import { TranslocoRootModule } from './transloco-root.module';
import { MatDialogModule } from "@angular/material/dialog";
import { FileDropDirective } from "../shared/directives/file-drop/file-drop.directive";
import { ReportComponent } from "./report/report.component";
import { UserProvisioningService } from "./services/user/user-provisioning.service";

@NgModule({
  declarations: [
    AppComponent,
    AssigneeComponent,
    PopulationRulesComponent,
    DocumentComponent,
    AnswerComponent,
    NavbarComponent,
    ReturnsComponent,
    SidebarComponent,
    ReportComponent,
    ClientSidebarComponent,
    PopulationSidebarComponent,
    TaxReturnSidebarComponent,
    ClientRulesSidebarComponent,
    DynamicSourcesComponent,
    DynamicSourcesDropdownComponent,
  ],
  imports: [
    ScrollingModule,
    SharedModule,
    LoginModule,
    TaxReturnsModule,
    TaxpayersSearchModule,
    SettingsModule,
    ClientsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NoticesModule,
    MsalModule,
    MsalConfigDynamicModule.forRoot(),
    TranslocoRootModule,
    MatDialogModule,
    FileDropDirective,
  ],
  providers: [
    APIS,
    Title,
    ClockService,
    {
      provide: Configuration,
      useValue: new Configuration({
        withCredentials: true,
        basePath: window.location.hostname === "localhost" ? "http://localhost:3000" : "rubix",
      })
    },
    {
      provide: APP_BASE_HREF,
      useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
      deps: [PlatformLocation]
    },
    CleanElementSelectorPipe,
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: EncodeJsonInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: WafRuleInterceptor, multi: true },
    ClientNotificationService,
    UserProvisioningService,
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
